import { Action } from 'redux';
import { IRemoteRefreshScheduleInfo } from '../../../ts/models/IRemoteRefreshScheduleInfo';
import { ChangeRemoteExtractRefresh } from '../AppActionTypes';

export interface ChangeRemoteExtractRefreshAction extends Action {
  schedule: IRemoteRefreshScheduleInfo;
}

export function changeRemoteExtractRefresh(schedule: IRemoteRefreshScheduleInfo): ChangeRemoteExtractRefreshAction {
  return {
    type: ChangeRemoteExtractRefresh,
    schedule,
  };
}
